import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'models';

const vendor = (state: RootState) => state.configurator.vendor;

const getSelectedCompanyVendorConfig = createSelector(
  vendor,
  ({ selectedCompanyVendorConfig }) => selectedCompanyVendorConfig,
);

const getAppliedFilters = createSelector(vendor, ({ appliedFilters }) => appliedFilters);

const getSubjectList = createSelector(vendor, ({ subjectList }) => subjectList);

const getSelectedVendorIdFromList = createSelector(vendor, ({ selectedVendorIdFromList }) => selectedVendorIdFromList);

const getIdEditedVendorFromList = createSelector(vendor, ({ idEditedVendorFromList }) => idEditedVendorFromList);

const getIsEditedVendorDetail = createSelector(vendor, ({ isEditedVendorDetail }) => isEditedVendorDetail);

const getSubjectTableColumns = createSelector(vendor, ({ subjectTableColumns }) => subjectTableColumns);

const getEditedRowIdVendorDetail = createSelector(vendor, ({ subjectDetails }) => subjectDetails.editedRowId);

const getSelectedRowIdVendorDetail = createSelector(
  vendor,
  ({ subjectDetails }) => subjectDetails.selectedRowId
);

const getSubjectDetailsTableRows = createSelector(vendor, ({ subjectDetails }) => subjectDetails.tableRows);

export default {
  getSelectedCompanyVendorConfig,
  getAppliedFilters,
  getSubjectList,
  getSelectedVendorIdFromList,
  getIdEditedVendorFromList,
  getIsEditedVendorDetail,
  getSubjectTableColumns,
  getEditedRowIdVendorDetail,
  getSelectedRowIdVendorDetail,
  getSubjectDetailsTableRows
};